import { cloneDeep, find, get, isEmpty, map } from "lodash";
import moment from "moment";
import "./weekView.scss";
import { createRef, useEffect, useRef, useState } from "react";
import { REMINDER_FUTURE_DATED_NO_ACTION, REMINDER_NO_ACTION, REMINDER_STATUS_COLOR_CODE, REMINDER_STATUS_COLOR_CODE_FOR_BACKGROUND } from "@utils/constants";
import { useRemindersContext } from "@components/drawerCalendar/useReminders";
import { ReminderTooltip } from "../reminderTooltip";
import Icon from "@assets/icon_config";
import { AllDayCadences } from "@components/drawerOutreaches/Cadence";
import { WEEK } from "@components/drawerCalendar/constant";

export const WeekView = ({ members, updateMembers, updateStatus }: any) => {
  // const [remindersList, setRemindersList] = useState<any>(rems);

  const { weekReminders, setWeekReminders, editReminderHandler, holidayList, selectDate, getTimeZoneInfo } = useRemindersContext();

  const dropPoint = useRef(0);
  const currentTimeLine = createRef<any>();
  const scrollContainerRef = useRef(null);
  const [currentDateInCurrentWeek, setCurrentDateInCurrentWeek] = useState(null);

  useEffect(() => {
    const scrollContainer: any = scrollContainerRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", () => {
        dropPoint.current = scrollContainer.scrollTop;
      });
    }
    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener("scroll", () => {
          dropPoint.current = scrollContainer.scrollTop;
        });
      }
    };
  }, []);

  useEffect(() => {
    isCurrentDateInCurrentWeek();
    currentTimeLine?.current?.scrollIntoView({
      block: "center",
      behavior: "smooth",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [weekReminders]);

  const isCurrentDateInCurrentWeek = () => {
    const date: any = getCurrentWeek().filter((item: any) => item?.split(",")?.[2]?.trim() === moment().format("YYYY-MM-DD"));
    setCurrentDateInCurrentWeek(date?.length ? date?.[0]?.split(",")?.[2]?.trim() : null);
  };

  const getCurrentWeek = () => {
    var currentDate = moment(selectDate);

    var weekStart = currentDate.clone().startOf("week");
    //   var weekEnd = currentDate.clone().endOf("isoWeek");

    var days = [];

    for (var i = 0; i <= 6; i++) {
      days.push(moment(weekStart).add(i, "days").format("DD,ddd, YYYY-MM-DD"));
    }
    return days;
  };

  // Function to stop drop event propagation on reminder card
  const dragOver = (e: any) => {
    e.preventDefault();
  };

  const drop = (e: any) => {
    e.preventDefault();
    const draggedReminder = get(JSON.parse(e.dataTransfer.getData("reminder")), "reminder");
    if (!draggedReminder?.reminderStatus || draggedReminder?.reminderStatus === REMINDER_NO_ACTION) {
      const targetDropContainerDate = e.target.id.split("--")?.[1];
      const reminderStart = moment.utc(draggedReminder?.reminderStartDate).local();
      const reminderEnd = moment.utc(draggedReminder?.reminderEndDate).local();

      if (targetDropContainerDate) {
        const yCoordinate = e.clientY;
        const time = ((dropPoint.current + yCoordinate - 118) / 120) * 100;
        const hour = Math.trunc(time / 100);
        const minutes = Math.trunc(((time % 100) / 120) * 60);
        const reminderStartDateTime = moment(targetDropContainerDate);
        reminderStartDateTime.add(hour, "hours");
        reminderStartDateTime.add(minutes <= 29 ? 0 : 30, "minutes");
        const differenceInMinutes = reminderEnd.diff(reminderStart, "minutes");
        const reminderEndDateTime = reminderStartDateTime.clone().add(differenceInMinutes, "minutes");
        const updatedReminderList = cloneDeep(weekReminders);
        const updatedReminder = {
          ...draggedReminder,
          reminderStartDate: reminderStartDateTime,
          reminderEndDate: reminderEndDateTime,
        };

        editReminderHandler(
          updatedReminder,
          () => {
            updatedReminderList[reminderStart.format("YYYY-MM-DD")] = updatedReminderList[reminderStart.format("YYYY-MM-DD")].filter((item: any) => item.reminderId !== draggedReminder.reminderId);

            if (updatedReminderList?.[targetDropContainerDate] && !isEmpty(updatedReminderList?.[targetDropContainerDate])) {
              if (find(weekReminders[targetDropContainerDate], { reminderId: draggedReminder.reminder.reminderId })) {
                updatedReminderList[targetDropContainerDate] = updatedReminderList?.[targetDropContainerDate]?.map((item: any) => {
                  let tempItem = cloneDeep(item);
                  if (draggedReminder.reminderId === tempItem.reminderId) {
                    tempItem = {
                      ...tempItem,
                      reminderStartDate: reminderStartDateTime,
                      reminderEndDate: reminderEndDateTime,
                    };
                  }
                  return tempItem;
                });
              } else {
                updatedReminderList[targetDropContainerDate] = [
                  ...updatedReminderList[targetDropContainerDate],
                  { ...draggedReminder, reminderStartDate: reminderStartDateTime, reminderEndDate: reminderEndDateTime },
                ];
              }
              updatedReminderList[targetDropContainerDate] = updatedReminderList[targetDropContainerDate].sort((a: any, b: any) => {
                const dateA = moment(a.reminderStartDate);
                const dateB = moment(b.reminderEndDate);
                return dateB.diff(dateA); // Compare in descending order
              });
            } else {
              updatedReminderList[targetDropContainerDate] = [{ ...draggedReminder, reminderStartDate: reminderStartDateTime, reminderEndDate: reminderEndDateTime }];
            }
            setWeekReminders(updatedReminderList);
          },
          members,
          updateMembers,
          updateStatus
        );
      }
    }
  };

  const getCurrentTimePosition = () => {
    const date = moment();
    const hr = date.hour();
    const min = date.minute();
    return hr * 120 + min * 2;
  };

  return (
    <div className="ui-healthEm-week-view" ref={scrollContainerRef}>
      <div className="ui-healthEm-week-view__header">
        <div className="ui-healthEm-week-view__header__filler-container"></div>
        {map(getCurrentWeek(), (item: string) => {
          const _item = item.split(",");
          return (
            <div className="ui-healthEm-week-view__header__wrapper">
              
            <div className={`ui-healthEm-week-view__header__day-date ${currentDateInCurrentWeek === _item?.[2]?.trim() ? "ui-healthEm-week-view__header__day-date__current-day" : ""}`}>
              <div className="ui-healthEm-week-view__header__day-date__day">{_item[1]}</div>
              <div className="ui-healthEm-week-view__header__day-date__date">{_item[0]}</div>
            </div>
              <AllDayCadences view={WEEK} date={_item[2]} />
            </div>
          );
        })}
        <div className="ui-healthEm-week-view__header__filler-container ui-healthEm-week-view__header__filler-container__timeZone">{getTimeZoneInfo()}</div>
      </div>
      <div className="ui-healthEm-week-view__content">
        <TimeSlotsForWeekView position={"left"} />
        {getCurrentWeek()?.map((day: any, dayIndex: any) => {
          const formattedDateStamp = day?.split(",")?.[2]?.trim();
          return (
            <div key={`day-${dayIndex}`} className="ui-healthEm-week-view__content__time-slot__weekday">
              <div className="ui-healthEm-week-view__content__time-slot__weekday__time-slot-container">
                {Array.from({ length: 24 }, (_, index) => index)?.map((item: any, weekDaySlotIndex: any) => {
                  return (
                    <div
                      key={`day-${dayIndex}-${weekDaySlotIndex}`}
                      className={`ui-healthEm-week-view__content__time-slot__weekday__time-slot-container__slot ${
                        moment(formattedDateStamp).day() === 0 || find(holidayList, { holiday_date: moment(formattedDateStamp).format("YYYY-MM-DD") })
                          ? "ui-healthEm-week-view__content__time-slot__weekday__time-slot-container__slot--disabled"
                          : ""
                      }
                      ${currentDateInCurrentWeek === formattedDateStamp ? "ui-healthEm-week-view__content__time-slot__weekday__time-slot-container__slot--current-day" : ""}`}
                    ></div>
                  );
                })}
              </div>
              <WeekDayReminderView day={formattedDateStamp} weekReminders={weekReminders[formattedDateStamp] || []} onDrop={drop} onDragOver={dragOver} />
              {currentDateInCurrentWeek && (
                <div
                  className="ui-healthEm-week-view__content__time-slot__weekday__time-slot-container__current-time"
                  style={{
                    transform: `translateY(${getCurrentTimePosition()}px)`,
                  }}
                  ref={currentTimeLine}
                />
              )}
            </div>
          );
        })}
        <TimeSlotsForWeekView position={"right"} />
      </div>
    </div>
  );
};

const TimeSlotsForWeekView = ({ position = "right" }) => {
  return (
    <div className="ui-healthEm-week-view__content__time-slot">
      {Array.from({ length: 24 }, (_, index) => index)?.map((item: any, index: any) => {
        const time = Math.trunc(item % 12) === 0 ? 12 : Math.trunc(item % 12);
        const slot = index >= 11 ? "PM" : "AM";
        return (
          <div className={`ui-healthEm-week-view__content__time-slot__slot ui-healthEm-week-view__content__time-slot__slot--${position}`}>
            {time} {slot}
          </div>
        );
      })}
    </div>
  );
};

const WeekDayReminderView = ({ day, weekReminders, onDrop, onDragOver }: any) => {
  const reminderList = weekReminders?.sort((a: any, b: any) => {
    const dateA = moment(a.reminderStartDate);
    const dateB = moment(b.reminderEndDate);
    return dateA.diff(dateB); // Compare in descending order
  });
  return (
    <div id={`week-view--${day}`} className="ui-healthEm-week-view__content__time-slot__weekday__reminder-container" onDrop={onDrop} onDragOver={onDragOver}>
      {reminderList?.map((reminder: any) => {
        return <Reminder day={day} reminder={reminder} weekReminders={reminderList} />;
      })}
    </div>
  );
};

const Reminder = ({ day, reminder, weekReminders }: any) => {
  const [onDragStart, setOnDragStart] = useState(false);

  // Function to handle when dragStarts
  const handleDragStart = (event: any, reminder: any) => {
    event.dataTransfer.setData("reminder", JSON.stringify({ reminder }));
  };

  const getStartPosition = (from: any) => {
    const date = moment.utc(from).local();
    const hr = date.hour();
    const min = date.minute();
    return hr * 120 + min * 2;
  };

  const getReminderDurationHeight = (from: any, to: any) => {
    const fromDate = moment(from);
    const toDate = moment(to);
    return toDate.diff(fromDate, "minutes") * 2;
  };

  const getReminderWidth = (from: any, to: any, reminderId: any) => {
    let count = [...weekReminders].filter((rem: any) => {
      return (
        moment.utc(from).format("YYYY-MM-DD HH:mm:ss") <= moment.utc(rem.reminderEndDate).format("YYYY-MM-DD HH:mm:ss") &&
        moment.utc(to).format("YYYY-MM-DD HH:mm:ss") >= moment.utc(rem.reminderStartDate).format("YYYY-MM-DD HH:mm:ss") &&
        reminderId !== rem.reminderId
      );
    }).length;
    return count > 0 ? 100 / (count + 1) : 100;
  };

  const getReminderLeft = (from: any, to: any, reminderId: any) => {
    const w = getReminderWidth(from, to, reminderId);
    const overlappedRem = [...weekReminders].filter((rem: any) => {
      return (
        moment.utc(from).format("YYYY-MM-DD HH:mm:ss") <= moment.utc(rem.reminderEndDate).format("YYYY-MM-DD HH:mm:ss") &&
        moment.utc(to).format("YYYY-MM-DD HH:mm:ss") >= moment.utc(rem.reminderStartDate).format("YYYY-MM-DD HH:mm:ss")
      );
    });
    return w === 100 ? 0 : w * overlappedRem.findIndex((rem) => rem.reminderId === reminderId);
  };

  const {reminderId , patientName , reminderTitle , reminderStatus , reminderStartDate , reminderEndDate , recurrence , reminderProgramName} = reminder || {};

  return (
    <ReminderTooltip reminder={reminder} onDragStart={onDragStart} placement={"top"}>
      <div
        id={`week-view--${day}--reminder-card`}
        className={`ui-healthEm-week-view__content__time-slot__weekday__reminder-container__reminder ${
          !reminderStatus || reminderStatus === REMINDER_NO_ACTION ? "" : "ui-healthEm-week-view__content__time-slot__weekday__reminder-container__reminder__disable-drag"
        }`}
        style={{
          transform: `translateY(${getStartPosition(reminderStartDate)}px)`,
          height: getReminderDurationHeight(reminderStartDate, reminderEndDate),
          background: `${
            REMINDER_STATUS_COLOR_CODE_FOR_BACKGROUND[
              reminderStatus ? reminderStatus : moment.utc(reminderEndDate).local() < moment() ? REMINDER_NO_ACTION : REMINDER_FUTURE_DATED_NO_ACTION
            ]
          }`,
          borderLeft: `4px solid ${
            REMINDER_STATUS_COLOR_CODE[
              reminderStatus ? reminderStatus : moment.utc(reminderEndDate).local() < moment() ? REMINDER_NO_ACTION : REMINDER_FUTURE_DATED_NO_ACTION
            ]
          }`,
          width: `${getReminderWidth(reminderStartDate, reminderEndDate, reminderId)}%`,
          left: `${getReminderLeft(reminderStartDate, reminderEndDate, reminderId)}%`,
        }}
        draggable={!reminderStatus || reminderStatus === REMINDER_NO_ACTION}
        onDragStart={(event) => {
          setOnDragStart(true);
          handleDragStart(event, reminder);
        }}
        onDragEnd={() => setOnDragStart(false)}
      >
        <div id={`week-view--${day}--reminder-card--header`} className="ui-healthEm-week-view__content__time-slot__weekday__reminder-container__reminder__header">
          <div id={`week-view--${day}--reminder-card--header--reminder-start-time`} className="ui-healthEm-week-view__content__time-slot__weekday__reminder-container__reminder__header__time">
            <div className="ui-healthEm-week-view__content__time-slot__weekday__reminder-container__reminder__header__time__left">
              <div className="ui-healthEm-week-view__content__time-slot__weekday__reminder-container__reminder__header__time__left__reminder-start-time">
                {moment.utc(reminderStartDate).local().format("h:mm A")}
              </div>
              {recurrence && (
                <div className="ui-healthEm-week-view__content__time-slot__weekday__reminder-container__reminder__header__time__left__recurring-reminder-icon">
                  <Icon name="refreshFilled" />
                </div>
              )}
            </div>
            {reminderProgramName && (
              <div className="ui-healthEm-week-view__content__time-slot__weekday__reminder-container__reminder__header__time__right">
                <div className="ui-healthEm-week-view__content__time-slot__weekday__reminder-container__reminder__header__time__right__program-name">{reminderProgramName}</div>
              </div>
            )}
          </div>
          {patientName && <div
            id={`week-view--${day}--reminder-card--header--reminder-start-time__patient-name`}
            className="ui-healthEm-week-view__content__time-slot__weekday__reminder-container__reminder__header__patient-name"
          >
            {patientName}
          </div>}
          <div className={`ui-healthEm-week-view__content__time-slot__weekday__reminder-container__reminder__reminder-description ${!patientName ? 'f18 w500' : ''}`}>
            {reminderTitle}
          </div>
        </div>
      </div>
    </ReminderTooltip>
  );
};
